import type { Handler } from './handler';
import type { ApiRedeemPromocodePort } from './ports/api-redeem-promocode.port';
import type {
  RedeemPromocodePayload,
  RedeemPromocodeResult,
} from '~/types/promocode';
import { resolveAdapter } from '~/adapters/registry';

export const redeemPromocodeHandler: Handler<Params, Ports, Result> = async (
  params,
  ports = {
    apiRedeemPromocode: resolveAdapter('apiRedeemPromocode'),
  },
) => {
  return await ports.apiRedeemPromocode.handle(params);
};

type Params = RedeemPromocodePayload;

type Ports = { apiRedeemPromocode: ApiRedeemPromocodePort };

type Result = Promise<RedeemPromocodeResult>;
